import { useCallback, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useModalStore } from '@/store/useModal'
import {
  useGetAllOutcome,
  useGetCreditCard,
  useGetOutcomeList,
  usePostManualBillingBillOrReserve,
  usePostManualBillingWithOutcome,
} from '@/modules/Users/queries/PatientQueries/Patient.queries'

const useChargesAndOutcomesModal = () => {
  const attendanceId = useParams()
  const { modalOpen, closeModal } = useModalStore()

  const idAttendance = Number(attendanceId?.userId)

  const [outcome, setOutcome] = useState('')
  const [card, setCard] = useState('')
  const [value, setvalue] = useState('')
  const [chargeAndOutcome, setChargeAndOutcome] = useState('')
  const [outcomeAttendance, setOutcomeAttendance] = useState('')

  const { outcomeData } = useGetOutcomeList(idAttendance)
  const { allOutcomeList } = useGetAllOutcome()

  const { creditCardList } = useGetCreditCard(idAttendance)

  const {
    manualBillingWithOutcomeIsLoading,
    manualBillingWithOutcomeMutation,
  } = usePostManualBillingWithOutcome()
  const {
    manualBillingBillOrReserveIsLoading,
    manualBillingBillOrReserveMutation,
  } = usePostManualBillingBillOrReserve()

  const handleOutcome = useCallback(
    value => {
      const filteredOutcome = allOutcomeList
        ?.filter(item => item.value === value)
        ?.map(item => item.key)
      setOutcomeAttendance(String(filteredOutcome))
    },
    [allOutcomeList],
  )

  const handleCreditCard = useCallback(
    value => {
      const filteredCreditCard = creditCardList
        .filter(item => item?.endAndFlagCard === value)
        .map(item => item?.id)
      setCard(String(filteredCreditCard))
    },
    [creditCardList],
  )

  const handleBillingAndOutcome = useCallback(() => {
    const params = {
      desfechoAtendimento: outcomeAttendance,
      idCartao: card,
      valor: value,
    }
    if (chargeAndOutcome === 'Desfecho pendente com pagamento') {
      manualBillingWithOutcomeMutation({
        params,
        idAttendance,
        outcomeType: 'com-cobranca',
      })
    }
    if (chargeAndOutcome === 'Desfecho pendente sem pagamento') {
      manualBillingWithOutcomeMutation({
        params,
        idAttendance,
        outcomeType: 'sem-cobranca',
      })
    }
    if (chargeAndOutcome === 'Cobrança manual') {
      manualBillingBillOrReserveMutation({
        params,
        idAttendance,
        outcomeType: 'cobrar',
      })
    }
    if (chargeAndOutcome === 'Reserva de valor') {
      manualBillingBillOrReserveMutation({
        params,
        idAttendance,
        outcomeType: 'reservar-pagamento',
      })
    }
  }, [
    card,
    chargeAndOutcome,
    idAttendance,
    manualBillingBillOrReserveMutation,
    manualBillingWithOutcomeMutation,
    outcomeAttendance,
    value,
  ])

  return {
    modalOpen,
    closeModal,
    outcomeData,
    chargeAndOutcome,
    setOutcome,
    outcome,
    handleBillingAndOutcome,
    allOutcomeList,
    creditCardList,
    setCard,
    setvalue,
    handleOutcome,
    setChargeAndOutcome,
    manualBillingWithOutcomeIsLoading,
    manualBillingBillOrReserveIsLoading,
    handleCreditCard,
  }
}

export default useChargesAndOutcomesModal
